/**
 * Sovereign API client + session token store.
 *
 * Single-user founder gate. The token lives in sessionStorage (clears
 * with the tab) so a closed browser equals a closed door.
 */
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api/admin/sovereign`;
const STORAGE_KEY = 'shreesavaa.sovereign.token';

export const getSovereignToken = () => {
  if (typeof window === 'undefined') return null;
  try { return window.sessionStorage.getItem(STORAGE_KEY); }
  catch { return null; }
};

const setSovereignToken = (t) => {
  try {
    if (t) window.sessionStorage.setItem(STORAGE_KEY, t);
    else window.sessionStorage.removeItem(STORAGE_KEY);
  } catch { /* ignore */ }
};

const auth = () => {
  const t = getSovereignToken();
  return t ? { headers: { Authorization: `Bearer ${t}` } } : {};
};

export const sovereignVerify = async (passphrase) => {
  const { data } = await axios.post(`${API}/verify`, { passphrase });
  setSovereignToken(data.token);
  return data;
};

export const sovereignWhoami = () => axios.get(`${API}/me`, auth()).then(r => r.data);
export const sovereignSnapshot = () => axios.get(`${API}/snapshot`, auth()).then(r => r.data);

export const sovereignSignOut = () => setSovereignToken(null);
